<template>
  <div class="success-page">
    <h1>Payment Successful!</h1>
    <p>Thank you for your purchase. Please check your email for further instructions.</p>
    <button @click="goToHome" class="home-button">Return to Home</button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { SEND_EMAIL } from "@/store/actions";
export default {
  name: "PaymentSuccessPage",
  mounted() {
    this.sendMultipleEmails();
  },
  methods: {
    ...mapActions("mailing", { sendEmail: SEND_EMAIL }),

    goToHome() {
      this.$router.push('/');
    },

    sendMultipleEmails() {
      const query = this.$route.query;
      const dataUser = {
        to: query.email,
        subject: "Confirmation de votre commande : Étude Numérologique à venir",
        text: `Cher(e) ${query.firstName} ${query.lastName},

          Nous vous remercions d'avoir choisi nos services pour votre étude numérologique personnalisée. Nous sommes ravis de vous annoncer que votre commande a été traitée avec succès.

          Votre étude numérologique est actuellement en cours de préparation. Comme il s'agit d'un travail personnalisé et détaillé, nous prenons le temps nécessaire pour assurer la qualité et la précision de notre analyse.

          Délai de livraison :
          Veuillez noter que vous recevrez votre étude complète par e-mail dans un délai de 72 heures. Nous vous prions de bien vouloir patienter pendant que nous mettons tout en œuvre pour vous fournir une analyse approfondie et perspicace.

          Que contiendra votre étude ?
          Votre rapport numérologique inclura une analyse détaillée de vos chiffres personnels, offrant des insights uniques sur votre personnalité, vos atouts, vos défis à venir, ainsi que des conseils personnalisés pour vous aider à naviguer dans votre parcours de vie.

          Besoin d'assistance ?
          Si vous avez des questions ou si vous avez besoin d'assistance, n'hésitez pas à nous contacter à [adresse e-mail du service client]. Notre équipe se fera un plaisir de vous assister.

          Nous vous remercions de votre patience et de votre confiance. Nous sommes impatients de vous fournir une étude numérologique qui, nous l'espérons, vous apportera des éclairages enrichissants.

          Cordialement, Jean-Luc`,
      };
      this.sendEmail(dataUser);

      const dataAdmin = {
        to: "c.hillereau@gmail.com",
        subject: "Nouvelle commande : Étude Numérologique à venir",
        text: `Bonjour, Christophe,

    Une nouvelle commande d'étude numérologique a été reçue avec les détails suivants :

    - Prénom : ${query.firstName}
    - Nom : ${query.lastName}
    - Date de naissance : ${query.birthDate}
    - Ville de naissance : ${query.birthCity}
    - Email : ${decodeURIComponent(query.email)}

    Vous pouvez générer la lecture de numérologie en suivant ce lien : https://jeanluc-ai.web.app/numerology-pdf

    Cordialement,
    L'équipe Numérologique`
      };
      this.sendEmail(dataAdmin);
    },
  },
};
</script>

<style scoped>
.success-page {
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #ffffff87;
  text-align: center;
}

h1 {
  color: #027015;
  margin-bottom: 20px;
}

p {
  margin-bottom: 30px;
}

.home-button {
  padding: 10px 20px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.home-button:hover {
  background-color: #0056b3;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>